module.exports = __webpack_public_path__ + "img/map-and-contact-slim.7ede2054.png";